import { eventsKeys } from '../constants';
import send from './send';

export default () => {
  send(eventsKeys.QUICK_SIGNUP_LOGIN_SUCCEED);
};
